// extracted by mini-css-extract-plugin
export default {"container":"styles_container__axC8F","IsLight":"styles_IsLight__Gh4I6","IsDark":"styles_IsDark__jPpqK"};